exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ColorCell {\n    height: 32px;\n    line-height: 32px;\n    text-align: center;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/ColorCell.css
// module id = 1096
// module chunks = 0